import React from "react";
import "../navbar.css";
import { Nav, NavItem, NavLink } from "reactstrap";

import "bootstrap/dist/css/bootstrap.css";

const Navbar = ({ token, username }) => {
  const reset = () => {
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("token");
  };
  if (token === "undefined" || !token) {
    return (
      <Nav className="background touch" card fill pills>
        <NavItem className="touch">
          <NavLink className="background bebas-neue-regular " href="/" path="/">
            Strength Shadow
          </NavLink>
        </NavItem>
        <NavItem className="active bebas-neue-regular" path="/login">
          <NavLink className="background" href="/login">
            Login
          </NavLink>
        </NavItem>
        <NavItem className="active bebas-neue-regular" path="/signup">
          <NavLink className="background" href="/signup">
            Sign-Up
          </NavLink>
        </NavItem>
      </Nav>
    );
  } else {
    return (
      <>
        <Nav card fill pills className="background touch">
          <NavItem className="active">
            <NavLink
              className="background bebas-neue-regular "
              href="/"
              path="/"
            >
              Strength Shadow
            </NavLink>
          </NavItem>
          <NavItem className="active">
            <NavLink
              className="background bebas-neue-regular "
              href="/workouts"
              path="/workouts"
            >
              Workouts
            </NavLink>
          </NavItem>
          <NavItem className="active">
            <NavLink
              className="background bebas-neue-regular "
              href="/users/profile"
              path="/users/profile"
            >
              Profile
            </NavLink>
          </NavItem>

          <NavItem className="active" path="/">
            <NavLink
              className="background bebas-neue-regular "
              href="/"
              onClick={reset}
            >
              Log Out {username}
            </NavLink>
          </NavItem>
        </Nav>
      </>
    );
  }
};

export default Navbar;
